import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import HCLAppscanCloudConfigListing from "./HCLAppscanCloudConfigListing";
import HCLAppscanCloudCredentialsForm from "./HCLAppscanCloudCredentialsForm";

export default function HCLAppscanCloudPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={HCLAppscanCloudCredentialsForm}
      PullConfigListingView={HCLAppscanCloudConfigListing}
    />
  );
}
